import axios from 'axios';

import * as CtaService from '../../services/cta';
import * as actionTypes from './actionTypes';
import { CTA_L_TRAINS } from '../../shared/constants';

export const setCtaBusRoutes = (data) => {
    const routes = data['bustime-response'].routes;
    return {
        type: actionTypes.SET_CTA_BUS_ROUTES,
        ctaBusRoutes: routes,
        loading: false
    };
};

export const setCtaTrainRoutes = () => {
    return {
        type: actionTypes.SET_CTA_TRAIN_ROUTES,
        ctaTrainRoutes: [...CTA_L_TRAINS],
        loading: false
    };
};

export const setSelectedRoute = (route) => {
    return {
        type: actionTypes.SET_SELECTED_ROUTE,
        route: route
    };
};

export const setSelectedDestination = (destination) => {
    return {
        type: actionTypes.SET_SELECTED_DESTINATION,
        destination: destination
    };
};

export const setSelectedBusStop = (busStop) => {
    return {
        type: actionTypes.SET_SELECTED_BUS_STOP,
        busStop: {...busStop}
    };
};

export const setSelectedTrainStation = (trainStation) => {
    return {
        type: actionTypes.SET_SELECTED_TRAIN_STATION,
        trainStation: {...trainStation}
    };
};

export const setSelectedTrainLine = (trainLine) => {
    return {
        type: actionTypes.SET_SELECTED_TRAIN_LINE,
        trainLine: trainLine
    };
};

export const setBusRouteDestinations = (data) => {
    const destinations = data['bustime-response'].directions;
    return {
        type: actionTypes.SET_BUS_ROUTE_DESTINATIONS,
        destinations: destinations,
        loading: false
    };
};

export const setBusStops = (data) => {
    const busStops = data['bustime-response'].stops;
    return {
        type: actionTypes.SET_BUS_STOPS,
        busStops: busStops,
        loading: false
    };
};

export const setBusStopPredictions = (data) => {
    const busTimeResponse = data['bustime-response'];
    if (busTimeResponse.prd) {
        return {
            type: actionTypes.SET_BUS_STOP_PREDICTIONS,
            predictions: busTimeResponse.prd,
            loading: false
        };
    }
    return noServiceScheduled(busTimeResponse.error[0]);
};

export const setTrainStationPredictions = (data) => {
    const arrivalResponse = data.ctatt;
    if (arrivalResponse.eta) {
        return {
            type: actionTypes.SET_TRAIN_STATION_PREDICTIONS,
            predictions: arrivalResponse.eta,
            loading: false
        };
    };
    return noServiceScheduled("No service at this time");
};

export const setTrainStations = (data) => {
    return {
        type: actionTypes.SET_TRAIN_STATIONS,
        trainStations: data,
        loading: false
    };
};

export const noServiceScheduled = (error) => {
    const { msg, stpid } = error;
    return {
        type: actionTypes.NO_SERVICE_SCHEDULED,
        message: msg && stpid? `${error.msg} for #${error.stpid}` : error,
        predictions: [],
        loading: false
    };
};

export const getStart = () => {
    return {
        type: actionTypes.GET_START,
        loading: true
    };
};

export const getFailed = (error) => {
    return {
        type: actionTypes.GET_FAILED,
        error: error,
        loading: false
    };
};

export const loadCtaBusRoutes = () => {
    return (dispatch) => {
        dispatch(getStart());
        axios.get(CtaService.getRoutes())
            .then(response => {
                dispatch(setCtaBusRoutes(response.data));
            })
            .catch(error => {
                dispatch(getFailed(error));
            });
    };
};

export const loadCtaTrainRoutes = () => {
    return (dispatch) => {
        dispatch(getStart());
        dispatch(setCtaTrainRoutes());
    };
};


export const loadBusRouteDestinations = (route) => {
    return (dispatch) => {
        dispatch(getStart());
        axios.get(CtaService.getDirections(route))
            .then(response => {
                dispatch(setBusRouteDestinations(response.data));
            })
            .catch(error => {
                console.error(error);
                dispatch(getFailed(error));
            });
    };
};

export const loadBusStops = (route, destination) => {
    return (dispatch) => {
        dispatch(getStart());
        axios.get(CtaService.getStops(route, destination))
            .then(response => {
                dispatch(setBusStops(response.data));
            })
            .catch(error => {
                dispatch(getFailed(error));
            });
    };
};

export const loadBusStopPredictions = (busStopId) => {
    return (dispatch) => {
        dispatch(getStart());
        axios.get(CtaService.getBusStopPredictions(busStopId))
            .then(response => {
                dispatch(setBusStopPredictions(response.data));
            })
            .catch(error => {
                dispatch(getFailed(error));
            });
    };
};

export const loadCtaTrainStations = (trainLineId) => {
    return (dispatch) => {
        dispatch(getStart());
        axios.get(CtaService.getLTrainStations(trainLineId))
            .then(response => {
                dispatch(setTrainStations(response.data));
            })
            .catch(error => {
                dispatch(getFailed(error));
            });
    };
};

export const loadCtaTrainStationPredictions = (stopId) => {
    return (dispatch) => {
        dispatch(getStart());
        axios.get(CtaService.getCtaTrainStationArrivals(stopId))
            .then(response => {
                dispatch(setTrainStationPredictions(response.data));
            })
            .catch(error => {
                console.log(error);
                dispatch(getFailed(error));
            });
    };
};


